<template>
  <v-container fluid class="pt-3">
    <v-layout row wrap class="control">
      <v-flex xs12 md12 class="text-center">
        <div class="pb-3">
          <el-select
            v-model="form.shop_reference"
            filterable
            placeholder="เลือกร้านค้า"
            :size="`small`"
            class="pr-2"
          >
            <el-option
              v-for="item in shopList"
              :key="item.shop_reference"
              :label="item.name"
              :value="item.shop_reference"
            ></el-option>
          </el-select>

          <el-date-picker
            size="small"
            v-model="daterange"
            type="daterange"
            value-format="yyyy-MM-dd"
            format="dd/MM/yyyy"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          ></el-date-picker>
          <el-button
            type="primary"
            :disabled="isLoading"
            class="ml-2"
            size="mini"
            @click="viewReport"
            >ค้นหา</el-button
          >
          <el-button
            type="primary"
            :disabled="isLoading"
            class="ml-2"
            size="mini"
            @click="downloadReport"
            >ดาวน์โหลด</el-button
          >
        </div>
      </v-flex>
    </v-layout>
    <el-card class="mt-3">
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="isLoading"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :mobile-breakpoint="`10`"
        @page-count="pageCount = $event"
        hide-default-footer
      >
        <template v-slot:item.ref_no="{ item }">{{ item.ref_no }}</template>
        <template v-slot:item.name="{ item }">{{ item.name }}</template>
        <template v-slot:item.quantity="{ item }">{{
          item.quantity | numFormat("0,0")
        }}</template>
        <template v-slot:item.food_amount="{ item }">{{
          item.food_amount | numFormat("0,0.00")
        }}</template>
        <template v-slot:item.delivery_amount="{ item }">{{
          item.delivery_amount | numFormat("0,0.00")
        }}</template>
        <template v-slot:item.discount_amount="{ item }">{{
          item.discount_amount | numFormat("0,0.00")
        }}</template>
        <template v-slot:item.grand_total="{ item }">{{
          item.grand_total | numFormat("0,0.00")
        }}</template>
        <!--
        <template v-slot:footer v-if="total!=null">
          <tr class>
            <td :colspan="headers"></td>
            <td class="font-weight-bold blue--text">รวมทั้งหมด</td>
            <td
              class="text-left font-weight-bold blue--text"
            >{{total.quantity | numFormat('0,0')}}</td>
            <td
              class="text-right font-weight-bold blue--text"
            >{{total.food_amount | numFormat('0,0')}}</td>
            <td
              class="text-right font-weight-bold blue--text"
            >{{total.delivery_amount | numFormat('0,0')}}</td>
            <td
              class="text-right font-weight-bold blue--text"
            >{{total.discount_amount | numFormat('0,0')}}</td>
          </tr>
        </template>
        -->
      </v-data-table>
    </el-card>
    <div
      style="position:fixed; bottom:10px; right:10px; z-index:9; width:100%;"
    >
      <v-pagination
        circle
        v-model="page"
        :total-visible="5"
        :length="pageCount"
      ></v-pagination>
    </div>
  </v-container>
</template>

<script>
import Service from "../../services";

import moment from "moment";
export default {
  components: {},
  data() {
    return {
      isLoading: true,
      daterange: [
        moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
      form: {
        shop_reference: "",
      },
      headers: [
        {
          text: "วันที่",
          align: "left",
          sortable: false,
          value: "date",
        },
        { text: "LINE User Ref", value: "line_user_id" },
        { text: "Latitude", value: "lat" },
        { text: "Longitude", value: "lng" },
      ],
      cash_amount: 0,
      transfer_amount: 0,
      creditcard_amount: 0,
      shopList: [],
      items: [],
      page: 1,
      itemsPerPage: 25,
      pageCount: 0,
      total: null,
    };
  },
  created() {
    Service.Shop.gets().then((res) => {
      if (res.success) {
        this.shopList = res.data.map((item) => {
          return {
            shop_reference: item.shop_id,
            name: item.name,
            status: item.status,
          };
        });

        this.shopList = this.shopList.filter(function(item) {
          return item.status == "published";
        });

        this.shopList.unshift({
          shop_reference: "",
          name: "ทั้งหมด",
          status: "published",
        });

        this.isLoading = false;
      }
    });
  },
  methods: {
    viewReport() {
      if (this.form.shop_reference == null) {
        return;
      }
      let data = {
        begin: this.daterange[0],
        end: this.daterange[1],
        type: "create_order",
        shop_ids: this.form.shop_reference,
      };

      Service.Report.location(data).then((res) => {
        this.items = res.data
          .filter((x) => x.lat != null)
          .map((item) => {
            return {
              ...item,
            };
          });
      });
    },

    downloadReport() {
      if (this.form.shop_reference == null) {
        return;
      }

      let params = {
        begin: this.daterange[0],
        end: this.daterange[1],
        type: "create_order",
        shop_ids: this.form.shop_reference,
        report: true,
      };

      var data = new FormData();
      data.append("begin", this.daterange[0]);
      data.append("end", this.daterange[1]);
      data.append("type", "create_order");
      data.append("shop_ids", this.form.shop_reference);
      data.append("report", true);

      let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
      let accessToken = vuex.Auth.accessToken;

      var request = new XMLHttpRequest();

      request.responseType = "blob";
      request.onreadystatechange = (e) => {
        let _ = this;

        let filename = "ยอดขายทั้งหมด_";
        if (this.selectedShopId != null && this.selectedShopId.length == 1) {
          filename = _.shopList.find((x) => x.shop_id == _.selectedShopId).name;
        }
        if (request.readyState !== 4) {
          return;
        }
        if (request.status === 200) {
          //console.log("success", request.response);
          var fileURL = window.URL.createObjectURL(
            new Blob([request.response], {
              type: "application/vnd.ms-excel",
            })
          );
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            "location_report_" + filename + ".csv"
          );
          document.body.appendChild(fileLink);

          fileLink.click();
        } else {
          console.warn(request);
        }
      };

      request.onload = function(oEvent) {
        var blob = request.response;
      };

      request.open(
        "POST",
        "https://hlzd-delivery-api.halalize.com/console/report/location"
      );
      request.setRequestHeader("Content-Type", "application/json");
      request.setRequestHeader("Authorization", "Bearer " + accessToken);
      //request.setRequestHeader("Accept", "*/*");
      //request.setRequestHeader("Origin", "dev-admin.foodhunt.com");
      //request.setRequestHeader("Host", "dev-order-api.foodhunt.com");
      request.send(JSON.stringify(params));
    },
  },
};
</script>
